import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import {IVendorOnboardApprovalEmailLinkResend, IVendorOnboardApprovalEmailAdd} from '../models/vendor-onboard-approval-search.model';

@Injectable({
  providedIn: 'root'
})
export class VendorOnboardApprovalSearchService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  public getAllVendorOnboardApprovalList(vendorOnboardApprovalSearchParam: IGlobalSearchParam): Observable<any> {
    return this.apiService.post(`VendorOnboardProcess/SearchVendorOnboardProcess`, vendorOnboardApprovalSearchParam)
  }

  public getVendorOnboardApprovalHistoryById(tempVendorId: number):Observable<any>{
    return this.apiService.getInd(`VendorOnboardProcess/StatusHistoryById/${tempVendorId}`)
  }

public resendEmailLink(value:IVendorOnboardApprovalEmailLinkResend):Observable<any>{
  return this.apiService.post(`VendorOnboardProcess/ReSendEmailLink`,value)
}

public resendEmailLinkNCA(value:IVendorOnboardApprovalEmailLinkResend):Observable<any>{
  return this.apiService.post(`VendorOnboardProcess/ReSendApplicantEmailLink`,value)
}

  public ExportVendorOnboardApprovalSearch(vendorOnboardApprovalSearchParam:IGlobalSearchParam):Observable<any> {
    return this.http.post(`${environment.apiRoot}VendorOnboardProcess/ExportVendorOnboardApporvalProcess`, vendorOnboardApprovalSearchParam,
    {  
        responseType: 'blob',
        observe: 'response'
     });
  }

}
